import { ElementEditMixin } from "%/dynamic-component-editor/mixins/element-edit-mixin";
import CarouselMixinProduction
  from "%/dynamic-component-editor/standard-elements/layouts/carousel-mixin-production";

const CarouselMixin = {
  elementPanelSettings: {
    tags: ["container", "layout", "carousel", "slider", "slideshow"],
    displayIcon: "bx:carousel",
    displayName: "Carousel",
    elementGroup: "layout",
    elementType: "basic",
  },
  mixins: [ElementEditMixin, CarouselMixinProduction],
  methods: {
    addItemToCarousel() {
      this.dynamicComponentInstance.addElement(
        {
          type: "Container",
          contents: [],
          options: {
            "default.layout-width": "fill",
            "default.layout-height": "fill",
            "default.border-radius": "large",
            "default.background-color": { "value": "paper", "source": "theme.background" },
            "default.border-sides": {
              "top": {
                "width": "standard", "color": { "value": "standard", "source": "theme.border" }, "style": "solid",
              },
              "right": {
                "width": "standard", "color": { "value": "standard", "source": "theme.border" }, "style": "solid",
              },
              "bottom": {
                "width": "standard", "color": { "value": "standard", "source": "theme.border" }, "style": "solid",
              },
              "left": {
                "width": "standard", "color": { "value": "standard", "source": "theme.border" }, "style": "solid",
              },
            },
          },
        },
        this.identifier,
        -1,
      );
    },
  },
};

export default CarouselMixin;
